import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getServerMonth,
  getServerYear,
  getServerDay,
  getPracticasDay,
  getPracticasMonth,
  daysInMonth,
} from "../helpers/getDates";
import PopPop from "react-poppop";

import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { StylesProvider } from "@material-ui/core/styles";
import SwipeableViews from "react-swipeable-views";

import Element from "../components/Element";

import "../components/Element.css";
import "../components/Screen.css";

import ClipLoader from "react-spinners/ClipLoader";

import { decode } from "html-entities";
import { screenActions } from "../store/screens-slice";

import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { containerVariants } from "../animations/transitions";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    "aria-controls": `nav-tabpanel-${index}`,
  };
}

function LinkTab(props) {
  return (
    <Tab
      component="a"
      onClick={(event) => {
        event.preventDefault();
      }}
      {...props}
    />
  );
}

export default function Practicas(props) {
  const [value, setValue] = useState(1);
  const [classes, setClasses] = useState("");
  const [indxNum, setIndxNum] = useState(0);
  const [showReservar, setShowReservar] = useState(false);
  const [showToolTip, setShowTooltip] = useState(true);
  const [show, setshow] = useState(true);

  const data = useSelector((state) => state.data.dataPracticas);

  const monthSelected = useSelector((state) => state.screens.monthSelected);

  const periodo = useSelector((state) => state.data.practicas.periodo);
  const disableClass = useSelector((state) => state.toggle.disable);
  const scrolldiv = useSelector((state) => state.screens.scrollDivPracticas);

  // DÍA, MES Y AÑO DEL SERVIDOR //
  const serverDate = useSelector((state) => state.data.serverDate);
  const [serverDay, setServerDay] = useState();
  const [serverMonth, setServerMonth] = useState();
  const [serverYear, setServerYear] = useState();

  useEffect(() => {
    if (serverDate) {
      setServerMonth(getServerMonth(serverDate));
      setServerYear(getServerYear(serverDate));
      setServerDay(getServerDay(serverDate));
    }
  }, [serverDate]);

  const fetchingError = useSelector((state) => state.data.fetchingError);
  const fetchingMessage = useSelector((state) => state.data.fetchingMessage);

  const [t, i18n] = useTranslation("global");

  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      setShowTooltip(false);
    }, 4000);

    window.addEventListener(
      "scroll",
      () => {
        setShowTooltip(false);
      },
      true
    );
    scrollTo();
    return () => {
      window.scrollTo(0, 0);
    };
  }, []);

  useEffect(() => {
    if (data[0].month.value.findesemana.length > 0) {
      if (periodo === "" || periodo === "entre_semana") {
        setValue(0);
        scrollTo();
      } else {
        setValue(1);
        scrollTo();
      }
    }
  }, [periodo]);

  useEffect(() => {
    scrollTo();
  }, [monthSelected, scrolldiv]);

  const scrollTo = () => {
    setTimeout(() => {
      let div = scrolldiv == "" ? `#${monthSelected}` : scrolldiv;

      if (scrolldiv || monthSelected) {
        const section = document.querySelector(div);

        if (scrolldiv === "#element_fechadespues") {
          window.scrollTo(0, 0);
        } else {
          if (section !== null) {
            section.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        }
      }
    }, 250);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClass = (value, reservarButton) => {
    setIndxNum(value);
    setShowReservar(reservarButton);

    if (value > 0) {
      setClasses(" element__disable");
    } else {
      setClasses("");
    }
  };

  const handleNext = () => {
    dispatch(screenActions.setMainScreen("reservar"));
  };

  return (
    <>
      {data[0].month.value.findesemana.length === 0 ? (
        <div className="screen__container">
          <ClipLoader color="#499bb1" loading={true} size={100} />
        </div>
      ) : (
        <>
          <StylesProvider injectFirst>
            <div
              // className={
              //   disableClass
              //     ? "position_sticky element__disable"
              //     : "position_sticky"
              // }
              className="position_sticky"
            >
              <AppBar position="static">
                <Tabs
                  variant="fullWidth"
                  value={value}
                  onChange={handleChange}
                  aria-label="nav tabs example"
                >
                  <LinkTab
                    label={t("PRACTICAS.labels.weekday")}
                    {...a11yProps(0)}
                  />
                  <LinkTab
                    label={t("PRACTICAS.labels.weekend")}
                    {...a11yProps(1)}
                  />
                </Tabs>
              </AppBar>
              <div
                className={`screen__toolTipContainer arrow-top ${
                  !showToolTip ? "screen__hideTooltip" : ""
                }`}
              >
                {t("PRACTICAS.tooltip")}
              </div>
            </div>
            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
              <SwipeableViews
                axis={"x"}
                variant="fullWidth"
                // fullwidth
                index={value}
                onChangeIndex={handleChangeIndex}
              >
                <TabPanel value={value} index={0}>
                  <div className="element__tab">
                    {data.map((item) => {
                      return item.month.value.entresemana.map((itm, idx) => {
                        if (itm !== null) {
                          if (itm.hasOwnProperty("id")) {
                            if (
                              daysInMonth(
                                getPracticasMonth(itm.fecha),
                                serverYear
                              ) -
                                getPracticasDay(itm.fecha) >=
                                6 &&
                              idx === item.month.value.entresemana.length - 1
                            ) {
                              return (
                                <div key={itm.id + idx}>
                                  {idx === 0 && (
                                    <h3
                                      className="element__monthName"
                                      key={item.month.name + itm.id}
                                    >
                                      {item.month.name}
                                    </h3>
                                  )}
                                  <div key={itm.id + idx}>
                                    <Element
                                      month={item.month.name}
                                      key={itm.id + itm.pracod}
                                      info={data}
                                      data={{ itm }}
                                      handleClass={handleClass}
                                      classes=""
                                      screen="practicas"
                                      tipo="entre_semana"
                                      modalidad={null}
                                    />

                                    <p className="element__error">
                                      {t("global:ELEMENT.no_more_practicas1")}
                                      {item.month.name}
                                      {t("global:ELEMENT.no_more_practicas2")}
                                    </p>
                                  </div>
                                </div>
                              );
                            } else {
                              return (
                                <div key={itm.id + idx}>
                                  {idx === 0 && (
                                    <h3 className="element__monthName">
                                      {item.month.name}
                                    </h3>
                                  )}
                                  <Element
                                    month={item.month.name}
                                    info={data}
                                    data={{ itm }}
                                    handleClass={handleClass}
                                    classes=""
                                    screen="practicas"
                                    tipo="entre_semana"
                                    modalidad={null}
                                  />
                                </div>
                              );
                            }
                          } else {
                            // si no hay prácticas entre semana!
                            return (
                              <p
                                key={itm.id + idx}
                                className={
                                  disableClass
                                    ? "screen__month element__disable"
                                    : `screen__month`
                                }
                                id={item.month.name}
                              >
                                <span>
                                  {" "}
                                  {`${
                                    item.month.name.charAt(0).toUpperCase() +
                                    item.month.name.slice(1)
                                  }: `}{" "}
                                </span>
                                {itm.includes("No hay") &&
                                  t("PRACTICAS.api.null_fecha_entresemana")}
                              </p>
                            );
                          }
                        }
                      });
                    })}
                  </div>
                </TabPanel>

                {/* / FIN DE SEMANA / */}

                <TabPanel value={value} index={1}>
                  <div className="element__tab">
                    {data.map((item) => {
                      return item.month.value.findesemana.map((itm, idx) => {
                        if (itm !== null) {
                          if (itm.hasOwnProperty("id")) {
                            if (
                              // Si quedan 1 finde para que acabe el mes y no hay más prácticas mostrar aviso
                              // Días del Mes - (Día de la práctica) >= 5 && idx === (month.length -1);
                              daysInMonth(
                                getPracticasMonth(itm.fecha),
                                serverYear
                              ) -
                                getPracticasDay(itm.fecha) >=
                                5 &&
                              idx === item.month.value.findesemana.length - 1
                            ) {
                              return (
                                <div key={itm.id + idx}>
                                  <Element
                                    month={item.month.name}
                                    info={data}
                                    data={{ itm }}
                                    handleClass={handleClass}
                                    classes=""
                                    screen="practicas"
                                    tipo="entre_semana"
                                    modalidad={null}
                                  />

                                  <p className="element__error">
                                    {t("global:ELEMENT.no_more_practicas1")}
                                    {item.month.name}
                                    {t("global:ELEMENT.no_more_practicas2")}
                                  </p>
                                </div>
                              );
                            } else {
                              //Caso en el que sí que hay prácticas todo el mes

                              return (
                                <div key={itm.id + idx}>
                                  {idx === 0 && (
                                    <h3 className="element__monthName">
                                      {item.month.name}
                                    </h3>
                                  )}
                                  <Element
                                    month={item.month.name}
                                    info={data}
                                    data={{ itm }}
                                    handleClass={handleClass}
                                    classes=""
                                    screen="practicas"
                                    tipo="fin_semana"
                                  />
                                </div>
                              );
                            }
                          } else {
                            // si no hay prácticas fin de semana
                            return (
                              <p
                                key={itm.id + idx}
                                className={
                                  disableClass
                                    ? "screen__month element__disable"
                                    : `screen__month`
                                }
                                id={item.month.name}
                              >
                                <span>
                                  {" "}
                                  {`${
                                    item.month.name.charAt(0).toUpperCase() +
                                    item.month.name.slice(1)
                                  }: `}{" "}
                                </span>
                                {itm.includes("No hay") &&
                                  t("PRACTICAS.api.null_fecha_findesemana")}
                              </p>
                            );
                          }
                        }
                      });
                    })}
                  </div>
                </TabPanel>
              </SwipeableViews>
            </motion.div>
          </StylesProvider>
          <div
            className={`screen__reservarContainer ${
              !showReservar && "element__disable"
            }`}
          >
            <button className="screen__reservarButton " onClick={handleNext}>
              {t("ELEMENT.button.book")}
            </button>
          </div>
        </>
      )}
    </>
  );
}
